
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Moment } from 'moment-timezone';
import { AppointmentsQueue } from '@/types/AppointmentsQueue';
import AppointmentsAdminSelector from '@/components/appointments/AppointmentsAdminSelector.vue';
import AppointmentsSignUp from '@/components/appointments/AppointmentsSignUp.vue';

import { library } from '@fortawesome/fontawesome-svg-core';
import { faFrownOpen } from '@fortawesome/free-solid-svg-icons';

library.add(faFrownOpen);

@Component({
	components: {
		AppointmentsSignUp,
		AppointmentsAdminSelector,
	},
})
export default class AppointmentsQueueDisplay extends Vue {
	@Prop({ required: true }) queue!: AppointmentsQueue;
	@Prop({ required: true }) loaded!: boolean;
	@Prop({ required: true }) ws!: WebSocket;
	@Prop({ required: true }) admin!: boolean;
	@Prop({ required: true }) time!: Moment;
}
